import EndLineAdornment from './EndLineAdornment';

export default EndLineAdornment;
